module.exports = __webpack_public_path__ + "static/ridge-projects-494701f6913452d9a31d8a9cdec9a40b.jpg";